import { AxiosError } from 'axios';

import { ZEE_BACKGROUND_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZeeBackground } from '@/types/zee.type';

export const getZeeBackground = async (): Promise<
  ApiResponse<ZeeBackground>
> => {
  try {
    const response = await apiManager.get(ZEE_BACKGROUND_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
